import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import _ from "i18n";

import {
  fetchAvailableDashboard,
  fetchPresentation,
  savePresentation,
  deleteComments,
  fetchDashboard
} from "Thunks";
import { onError } from "Utils";
import {
  AddComment,
  setPresentationExtraSlides,
  setPresentationHiddenSlides,
  setDashboardListFilterStatus,
  setDashboardListPaginationPage,
  setDashboardListFilter,
  setDashboardListFilterNewDashboardIds,
  setDashboardListFilterisPublic
} from "Actions";

import DashboardListFetching from "../DashboardList/DashboardMiniListFetching";
import DashboardFilter from "../DashboardList/DashboardFilter";
import { TTPReactModal } from "../Common/Modal/TTPReactModal";
import styles from "./PreparePresentation.local.scss";
import TTPPaginator from "../Common/TTPPaginator";
import MiniItem from "../DashboardList/MiniItem";
import NotFoundV2 from "../NotFound/NotFoundV2";
import Slide from "../Dashboard/Slide";
import TTPFilterHorizontalBar from "../Common/filters/TTPFilterHorizontalBar";

class DashboardTemplatesFrame extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      selectedStates: ["ALL"],
      showDashboard: null,
      selectedDashboard: null,
      dashboardsStatus: []
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { filter, paginationPage } = prevProps;
    if (
      filter !== this.props.filter ||
      paginationPage !== this.props.paginationPage
    ) {
      this.props.dispatch(fetchAvailableDashboard());
    }
  }

  handleCancel = () => {
    this.props.onCancel();
  };

  handleDisplayDashboardSlidesModal = dashboard => {
    this.setState({ showDashboard: dashboard });
  };

  cancelDashboardSlidesModal = () => {
    this.setState({ showDashboard: null });
  };
  handleChangeDashboardsStatus = value => {
    this.setState({ dashboardsStatus: value });
  };

  handleCancelDashboard = () => {
    this.setState({
      selectedDashboard: null
    });
  };

  handleSelectDashboard = dashboard => {
    this.setState({
      selectedDashboard: dashboard
    });
  };

  handleChangeFilterValue = value => {
    this.setState({ selectedStates: [value] });
    this.props.dispatch(setDashboardListFilterStatus(value));
    this.props.dispatch(fetchAvailableDashboard());
  };

  renderPaginate() {
    let { dashboards, paginationPage, nbResult } = this.props;
    if (dashboards.error != null && dashboards.error.code === 404) {
      return "";
    }
    return (
      <TTPPaginator
        onPageChange={this.handleDashboardListPageChange}
        pageSize={6}
        nbResult={nbResult}
        paginationPage={paginationPage}
      />
    );
  }

  handleDashboardListPageChange = ({ selected }) => {
    this.props.dispatch(setDashboardListPaginationPage(selected + 1));
  };

  handleConfirmDashboard = () => {
    const { commentsIds, dispatch, year, uen } = this.props;
    let { selectedDashboard } = this.state;

    dispatch(setPresentationExtraSlides(0));
    dispatch(setPresentationHiddenSlides([]));
    commentsIds && commentsIds.length && dispatch(deleteComments(commentsIds));

    dispatch(
      savePresentation(uen, year, { dashboard: selectedDashboard })
    ).then(
      res => {
        dispatch(fetchDashboard(year, uen, uen, null));
        dispatch(fetchPresentation(uen, year));
        dispatch(AddComment([]));
        this.handleCancel();
      },
      err =>
        onError(
          err.response && err.response.data.errors
            ? err.response.data.errors[0].message
            : "errorOccured"
        )
    );
  };
  onTabChange = value => {
    let { dispatch } = this.props;
    this.setState({ selectedStates: [value] });
    dispatch(setDashboardListFilter(""));
    dispatch(setDashboardListFilterNewDashboardIds([]));
    dispatch(setDashboardListFilterisPublic("", ""));

    if (value === "SHARED") {
      dispatch(setDashboardListFilterisPublic("false", "neq"));
    }
    if (
      value === "LIBRARY" ||
      value === "MyTemplates" ||
      value === "Templates"
    ) {
      dispatch(setDashboardListFilter(value));
    }
    dispatch(
      setDashboardListFilterStatus(
        value === "CREATED" || value === "STANDARD" ? [value] : []
      )
    );
  };
  render() {
    const {
      fetching,
      fetched,
      dashboards,
      backOffice,
      withoutHeader
    } = this.props;
    let {
      showDashboard,
      selectedDashboard,
      selectedStates,
      dashboardsStatus
    } = this.state;
    return (
      <div
        className={classnames(
          styles.list_mini_items,
          withoutHeader ? styles.list_mini_items_withoutHeader : ""
        )}
      >
        {selectedDashboard && (
          <div className={styles.modal_sum_up}>
            <h5>{_("selectedModeleDashboard")}</h5>
            <div style={{ display: "flex" }}>
              <MiniItem
                key={`dashboard-${selectedDashboard.id}`}
                dashboard={selectedDashboard}
                toApprove
                {...selectedDashboard}
                displayDashboardSlides={this.handleDisplayDashboardSlidesModal}
                onCancelDashboard={this.handleCancelDashboard}
              />
              <div className={styles.modal_sum_up_details}>
                <span>{_("attention")} !</span>
                <ul>
                  <li>{_("deleteCommentsWarning")}</li>
                  <li>{_("deleteHiddenSlidesWarning")}</li>
                  <li>{_("desableExtraSlidesWarning")}</li>
                </ul>
              </div>
            </div>
          </div>
        )}
        <h5>{_("availableModeleDashboard")}</h5>
        <DashboardFilter
          selectedStates={selectedStates}
          onFilterValueChange={this.handleChangeFilterValue}
          onTabChange={this.onTabChange}
          handleChangeDashboardsStatus={this.handleChangeDashboardsStatus}
          isDashboardTemplateFrame={true}
        />
        <div
          className="row align-center medium-11"
          style={{ marginTop: "-7px" }}
        >
          <div className={`medium-12`}>
            <TTPFilterHorizontalBar
              onTabChange={this.onTabChange}
              tabs={backOffice ? [] : dashboardsStatus}
              selectedTab={selectedStates}
              cssClass="medium-12"
              HideButton={true}
            />
          </div>
        </div>
        {showDashboard && (
          <TTPReactModal
            title={_("visualiseDashboard")}
            isOpen={showDashboard !== null}
            onCancel={this.cancelDashboardSlidesModal}
            width={1100}
            extraSlideModal={true}
          >
            {showDashboard.slides.map((slide, i) => {
              return (
                <Slide
                  key={i}
                  slide={slide}
                  isResponsive={true}
                  handleDisplayAnnexePDF={null}
                  comments={[]}
                  dashboardPage={true}
                />
              );
            })}
          </TTPReactModal>
        )}
        {fetching && <DashboardListFetching />}
        {fetched && dashboards.length ? (
          <Fragment>
            <div className="row">
              {dashboards.map((item, i) => {
                return (
                  <MiniItem
                    key={`dashboard-${item.id}`}
                    dashboard={item}
                    {...item}
                    displayDashboardSlides={
                      this.handleDisplayDashboardSlidesModal
                    }
                    selectDashboard={this.handleSelectDashboard}
                  />
                );
              })}
            </div>
            {fetched && dashboards.length ? (
              this.renderPaginate()
            ) : (
              <div className="row pagination" />
            )}
          </Fragment>
        ) : (
          !fetching && <NotFoundV2 />
        )}
        <div
          className={classnames(
            styles.slides_footer,
            withoutHeader ? styles.footer_withoutHeader : ""
          )}
        >
          <button className={styles.cancel_btn} onClick={this.props.onCancel}>
            {_("cancel")}
          </button>
          <button
            className={classnames(
              styles.validate_btn,
              !selectedDashboard && styles.disabled_btn
            )}
            onClick={() => this.handleConfirmDashboard()}
          >
            {_("validate")}
          </button>
        </div>
      </div>
    );
  }
}
// Connected Component
const mapStateToProps = state => ({
  paginationPage: state.dashboardList.paginationPage,
  filter: state.dashboardList.filter,
  fetching: state.dashboardList.fetching,
  nbResult: state.dashboardList.nbResult,
  dashboards: state.dashboardList.items,
  fetched: state.dashboardList.fetched,
  lng: state.params.lng,
  backOffice: state.params.backOffice,
  withoutHeader: state.auth.withoutHeader
});

export default connect(mapStateToProps)(DashboardTemplatesFrame);



// WEBPACK FOOTER //
// ./src/components/PreparePresentation/DashboardTemplatesFrame.js